const mediaItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20film%20scene%20with%20warm%20golden%20lighting%2C%20emotional%20character%20moment%2C%20movie%20poster%20aesthetic%2C%20soft%20focus%20background%20with%20film%20grain%2C%20professional%20cinematography%2C%20dark%20moody%20atmosphere%20with%20warm%20highlights&width=600&height=400&seq=media-01&orientation=landscape',
    title: '本周必看：《沙丘2》深度解析',
    desc: '从沙漠史诗到科幻新标杆，维伦纽瓦如何用视觉语言重新定义科幻电影美学',
    tag: '深度影评',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20dramatic%20explosion%20silhouette%2C%20warm%20orange%20and%20gold%20fire%20lighting%2C%20cinematic%20atmosphere%2C%20film%20poster%20style%20composition%2C%20dark%20shadow%20foreground%2C%20professional%20movie%20visual%2C%20epic%20scale%20scene&width=600&height=400&seq=media-02&orientation=landscape',
    title: '暑期档动作片大盘点',
    desc: '从超级英雄到硬核格斗，今夏最值得期待的动作巨制一次看够',
    tag: '观影指南',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20film%20scene%20with%20soft%20golden%20sunset%20lighting%2C%20two%20silhouettes%20against%20warm%20sky%2C%20cinematic%20movie%20poster%20aesthetic%2C%20dreamy%20atmosphere%2C%20film%20grain%20texture%2C%20elegant%20composition%2C%20soft%20bokeh%20background&width=600&height=400&seq=media-03&orientation=landscape',
    title: '小众佳片推荐：被忽视的宝藏',
    desc: '那些评分高却看的人少的冷门好片，每一部都值得高清大屏细细品味',
    tag: '精选推荐',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选影评与专题推荐，帮你发现下一部心头好电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="bg-background-200/60 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/20 transition-all duration-200 group cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-accent-500 text-background-950 font-semibold px-2.5 py-1 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}